import React, { useEffect, useState } from "react";
import "../exercise1/Exercise1Summary.css";
import { useNavigate, useLocation } from "react-router-dom";
import confettiSvg from "../components/icons/Confetti.svg";
import homeIcon from "../components/icons/Home.svg";


const Exercise9FullyComplete = () => {
  const [showConfetti, setShowConfetti] = useState(true);
  const location = useLocation();
  const currentTime = location.state?.currentTime || 0;
  const highestTime = location.state?.highestTime || 0;
  const duration = location.state?.duration || 1; // Get duration from navigation state

  const navigate = useNavigate();

  // Hide confetti after animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 4000); // Confetti disappears after 4 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleNextSection = () => {
    navigate("/exercise10"); // Navigates back to the intro for the next duration
  };

  return (
    <div className="exercise-summary-container">
      {showConfetti && (
        <div className="confetti-container">
          <img
            src={confettiSvg}
            alt="Confetti"
            className="confetti-animation"
          />
        </div>
      )}

      <h1>Congratulations on completing Exercise 9</h1>
      <p>
        The rhythmic breathing you experienced will be used throughout the next
        few exercises. If you want a refresher on how to rhythmically breathe,
        you may come back to this exercise whenever you please.
      </p>

      <div className="improvement-section">
        <div className="improvement-text">
          <p>
            <strong>Click "Next" to move on to the next Exercise.</strong>
          </p>
          <p>Hint: Do this exercise for longer to increase focus time.</p>
        </div>
      </div>

      <div className="bottom-buttons">
        <button className="home-button" onClick={() => navigate("/")}>
          <img src={homeIcon} alt="Home" className="home-icon" />
        </button>
        <button className="next-button" onClick={handleNextSection}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Exercise9FullyComplete;
